export default {"src":"/_next/static/media/external-icon.fcae0418.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};